import { render, staticRenderFns } from "./LevelUpModal.vue?vue&type=template&id=3ef9249d&"
import script from "./LevelUpModal.vue?vue&type=script&lang=js&"
export * from "./LevelUpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports